<template>
  <div class="terms">
    <section class="c_policies">
      <div class="container">
        <div class="">
      
          <div class="policy_header">
            <h1>特定商取引法に基づく表記</h1>
          </div>
          <div class="policy_body">
            <h2>1.	販売業者</h2>
            <div class="c_policy_child_body child_body_id_1">
              <p>株式会社クラップ</p>
            </div>

            <h2>2.	運営責任者</h2>
            <div class="c_policy_child_body child_body_id_1">
              <p>泉　健太</p>
            </div>

            <h2>3.	所在地</h2>
            <div class="c_policy_child_body child_body_id_1">
              <p>〒150-0046</p>
              <p>東京都渋谷区松濤1-25-16</p>
              <p>株式会社クラップ</p>
            </div>

            <h2>4.	電話番号/FAX</h2>
            <div class="c_policy_child_body child_body_id_1">
              <p>～～～</p>
            </div>

            <h2>5.	メールアドレス</h2>
            <div class="c_policy_child_body child_body_id_1">
              <p>info@コモリ</p>
            </div>

            <h2>6.	商品のお届け</h2>
            <div class="c_policy_child_body child_body_id_1">
              <p>代金決済後、すぐにご利用開始いただけます。</p>
            </div>

            <h2>7.	商品以外の代金について</h2>
            <div class="c_policy_child_body child_body_id_1">
              <p>なし</p>
            </div>

            <h2>8.	代金の支払い時期</h2>
            <div class="c_policy_child_body child_body_id_1">
              <p>ご利用時の都度課金</p>
            </div>

            <h2>9.	お支払い方法</h2>
            <div class="c_policy_child_body child_body_id_1">
              <p>クレジットカード決済</p>
            </div>

            <h2>10.	途中退会の場合</h2>
            <div class="c_policy_child_body child_body_id_1">
              <p>途中退会を行った場合、商品の性質上、返金は受け付けないものとします。</p>
            </div>

            <h2>11.	返品交換</h2>
            <div class="c_policy_child_body child_body_id_1">
              <p>返品/交換はお受けできません。</p>
            </div>
          </div>
          <div class="policy_footer">
            <p>comoroi</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  methods: {
  },
  data () {
    return {
    }
  },
  components: {
  },
  mounted () {
  },
  methods: {
  },
}
</script>
<style scoped lang="scss">
  .terms {
    padding-left: 4vw;
    padding-right: 4vw;
  }

  .bp-each-content .part-text {
	  text-align: left;
	}

	.c_policies {
	  padding: 50px 0px;
	}

	.c_policies  h1{
	  font-size: 40px;
	  font-weight: bold;
	  line-height: 2;
	  width: 100%;
	  width: 100%;
	  text-align: center;
	}


	.c_policies h2 {
	    font-size: 30px;
	    line-height: 42px;
	    font-weight: bold;
	    display: block;
	    width: 100%;
	    margin-top: 30px;
	}

	.c_policies p,
	.c_policy_child_body p {
	    font-size: 18px;
	    line-height: 36px;
	    font-weight: normal;
	    display: block;
	    color: #7E7B72;
	}

	.policy_header {
	  padding: 30px 0px 0px;
	}

	.policy_header p {
	  font-weight: bold;
	  color: black;
	  font-size: 22px;
	  line-height: 1.3;
	}

	.policy_footer p {
	  font-weight: bold;
	  color: black;
	  font-size: 20px;
	  line-height: 1.3;
	  text-align: center;
	}

	.policy_b ody {
	  padding: 30px 0px;
	}

	.c_child_tab_1 {
	  padding-left: 10px;
	}

	.c_child_tab_2 {
	  padding-left: 20px;
	  
	}

	.c_child_tab_3 {
	  padding-left: 30px;

	}
</style>